// extracted by mini-css-extract-plugin
export var audioPlayer = "_r5-0";